var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("g", { stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            React.createElement("path", { fill: "none", d: "M0 0h48v48H0z" }),
            React.createElement("path", { d: "M32.752 34c.337 0 .634-.129.891-.386.238-.237.357-.534.357-.89s-.139-.673-.416-.95L25.798 24l7.786-7.774c.277-.277.416-.604.416-.98 0-.336-.129-.623-.386-.86a1.131 1.131 0 00-.862-.386c-.357 0-.674.138-.951.415l-7.786 7.805-7.816-7.805c-.277-.277-.584-.415-.921-.415-.357 0-.654.129-.892.386a1.16 1.16 0 00-.386.89c0 .336.139.653.416.95L22.232 24l-7.816 7.774c-.277.277-.416.594-.416.95s.129.653.386.89c.238.257.535.386.892.386.337 0 .644-.148.921-.445l7.816-7.775 7.786 7.775c.297.297.614.445.95.445z", fill: "currentColor", fillRule: "nonzero" }))));
});
